export function releaseStatus(release, now, locale, labels) {
  const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(release);
  if (!parts) return null;
  const [year, month, day] = parts.slice(1).map(Number);
  const eastern = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const value = type => Number(eastern.find(part => part.type === type).value);
  const remaining = Math.round((Date.UTC(year, month - 1, day) - Date.UTC(value('year'), value('month') - 1, value('day'))) / 86400000);
  const date = new Intl.DateTimeFormat(locale || 'en', { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(Date.UTC(year, month - 1, day, 17)));
  const text = remaining > 0 ? labels.before.replace('{days}', new Intl.NumberFormat(locale || 'en').format(remaining)) : remaining === 0 ? labels.today : labels.past.replace('{date}', date);
  return { remaining, text };
}

if (typeof document !== 'undefined') {
  let timer;
  const update = () => {
    clearTimeout(timer);
    const roots = document.querySelectorAll('.tcg-autumn-home');
    roots.forEach(root => {
      const labels = { before: root.dataset.calendarBefore, today: root.dataset.calendarToday, past: root.dataset.calendarPast };
      if (!labels.before || !labels.today || !labels.past) return;
      root.querySelectorAll('[data-date]').forEach(element => {
        const status = releaseStatus(element.dataset.date, new Date(), root.dataset.calendarLocale, labels);
        if (status) element.textContent = status.text;
      });
    });
    if (roots.length && !document.hidden) timer = setTimeout(update, 60000);
  };
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', () => { clearTimeout(timer); });
  update();
}
